import type { DetalleOT } from "../types/ot.types";

export type AprobacionEstado = DetalleOT["aprobacion_cliente"];

export function mapAprobacionEstado(
  value: number | string | null | undefined,
): AprobacionEstado {
  if (value === 1 || value === "1") return "aprobado";
  if (value === 0 || value === "0") return "rechazado";
  return "pendiente";
}

export function mapDetalleExpedienteToOT(d: Record<string, unknown>): DetalleOT {
  return {
    id: Number(d.clave_orden_trabajo_detalle),
    clave_orden_trabajo_detalle: Number(d.clave_orden_trabajo_detalle),
    categoria: String(d.clave_categoria || ""),
    categoria_label: String(d.categoria || ""),
    subcategoria: String(d.clave_subcategoria || ""),
    subcategoria_label: String(d.subcategoria || ""),
    subcategoriadetalle: String(d.clave_subcategoria_detalle || ""),
    subcategoria_detalle_label: String(d.titulo || ""),
    observaciones: String(d.observaciones || ""),
    pago_por_cliente: false,
    causa: "",
    cantidad: Number(d.cantidad) || 1,
    garantia: "No",
    precio_unitario_sin_iva: Number(d.precio_unitario) || 0,
    porcentaje_iva: Number(d.porcentaje_iva) || 16,
    porcentaje_isr: Number(d.porcentaje_isr) || 0,
    aprobacion_cliente: mapAprobacionEstado(d.autorizado as number | null),
    aprobacion_admin: mapAprobacionEstado(d.clave_aprobacion as number | null),
    motivo_rechazo_cliente: String(d.motivo_rechazo_cliente || ""),
    motivo_rechazo_admin: String(d.motivo_rechazo_admin || ""),
    evidencia_omitida: d.evidencia_omitida == 1,
  };
}

const APROBACION_BADGE: Record<
  AprobacionEstado,
  { className: string; icon: string; label: string }
> = {
  aprobado: { className: "bg-success", icon: "fa-check-circle", label: "Aprobado" },
  rechazado: { className: "bg-danger", icon: "fa-times-circle", label: "Rechazado" },
  pendiente: { className: "bg-secondary", icon: "fa-clock", label: "Pendiente" },
};

export function getAprobacionBadgeConfig(estado: AprobacionEstado) {
  return APROBACION_BADGE[estado];
}

export function getConceptoCardBorderClass(detalle: DetalleOT): string {
  if (
    detalle.aprobacion_cliente === "rechazado" ||
    detalle.aprobacion_admin === "rechazado"
  ) {
    return "border-danger border-2";
  }
  if (
    detalle.aprobacion_cliente === "aprobado" &&
    detalle.aprobacion_admin === "aprobado"
  ) {
    return "border-success";
  }
  return "border-secondary border-opacity-25";
}
